import { useHistory } from "react-router-dom";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { DemoItem } from "./demos-page";

type DemoCardProps = DemoItem & {
  status: string;
  thumbnail: string;
};

export const DemoCard = (props: DemoCardProps) => {
  const history = useHistory();

  return (
    <Card
      onClick={() => history.push(props.path)}
      className="group flex flex-row overflow-hidden cursor-pointer hover:bg-accent/50 transition-colors py-0 gap-0"
    >
      <div className="w-62.5 shrink-0 bg-muted overflow-hidden">
        <img
          src={props.thumbnail}
          alt={props.title}
          className="w-full h-full object-cover"
        />
      </div>
      <div className="flex flex-col flex-1 min-w-0">
        <CardHeader className="pt-4 pb-0 gap-1">
          <CardTitle className="text-base">{props.title}</CardTitle>
        </CardHeader>
        <CardContent className="flex flex-col gap-3 py-4 flex-1">
          <div className="flex flex-wrap gap-1.5">
            {props.categories.map((category) => (
              <Badge key={category} variant="outline">
                {category}
              </Badge>
            ))}
            <Badge
              variant="outline"
              className={
                props.status === "private"
                  ? "border-amber-500 text-amber-600 dark:text-amber-400"
                  : "border-emerald-500 text-emerald-600 dark:text-emerald-400"
              }
            >
              {props.status === "private" ? "Private" : "Public"}
            </Badge>
          </div>
          <CardDescription className="text-sm">
            {props.description}
          </CardDescription>
        </CardContent>
      </div>
    </Card>
  );
};
